import React, { useState, Fragment, Component } from 'react'
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button
} from "reactstrap"
import { Link, useHistory, useParams } from "react-router-dom"
import { withRouter } from "react-router";
import { Preview } from '../../../../helpers/ui/FileInput'
import apiResponse from '../../../../services/apiResponse'
import moment from 'moment';
import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar';

import DetailBloc from './Blocs/DetailBloc'

class IndexView extends Component {

    detailBloc = new DetailBloc()

    constructor(props) {
        super(props)
        this.state = {}
    }

    dateParse = (input) =>{
        let res = "-";
        if (input != "" && input != null){
            res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    componentDidMount() {
        this.detailBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        this.setState({
                            detail: response
                        })
                        //console.log(response)
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(this.props.location.search)
        this.detailBloc.fetchDetail({uuid: queryParams.get('uuid') })
    }

    componentWillUnmount(){
        this.detailBloc.detailChannel.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <PegawaiSideBar active="riwayat_pangkat"/>

                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <CardTitle>Detail Riwayat Kepangkatan</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Informasi Detail Riwayat Kepangkatan
                                    </CardSubtitle>
                                    <hr />

                                     <Row className="mb-3">
                                        <label className="col-md-4">
                                        Pangkat
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.rank_name !== "" ? this.state.detail.rank_name : '-'}</>
                                                : <Shimmer><div style={{width: 300, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-4">
                                        Golongan/Ruang
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.rank_group_room !== "" ? this.state.detail.rank_group_room : '-'}</>
                                                : <Shimmer><div style={{width: 300, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-4">
                                        TMT Pangkat
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.rank_history_tmt_date !== "" ? this.dateParse(this.state.detail.rank_history_tmt_date) : '-'}</>
                                                : <Shimmer><div style={{width: 200, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-4">
                                        Nomor SK
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.rank_history_decree_number !== "" ? this.state.detail.rank_history_decree_number : '-'}</>
                                                : <Shimmer><div style={{width: 200, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-4">
                                        Tanggal SK
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.rank_history_decree_date !== "" ? this.dateParse(this.state.detail.rank_history_decree_date) : '-'}</>
                                                : <Shimmer><div style={{width: 200, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-4">
                                            File SK KP
                                        </label>
                                        <Col md="8">
                                            {
                                                this.state.detail ?
                                                    <>
                                                        {this.state.detail.document_sk !== null ?  
                                                            <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.detail.document_sk.documents_path}>
                                                                Download <i className="fa fa-download ms-1"></i>
                                                            </a>
                                                        : '-'}
                                                    </>
                                                :
                                                    <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                   
                                    <Row className="mb-3">
                                        <Col md="4"></Col>
                                        <Col md="8">
                                            <Link to="/kepegawaian/home.html?riwayat_pangkat" className="waves-effect">
                                                <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                            </Link>
                                        </Col>
                                    </Row>
                                    
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }
}

//export default IndexView
export default withRouter(IndexView);